import { useEffect, useState } from 'react';
import { findSection, type Section } from '../sections/registry.ts';

export interface HashRoute {
  readonly section: string;
  readonly path: readonly string[];
  readonly params: URLSearchParams;
}

export function parseHashRoute(hash: string): HashRoute {
  const [location = '', query = ''] = hash.replace(/^#\/?/, '').split('?', 2);
  const [section = '', ...path] = location.split('/').filter((part) => part !== '');
  return { section, path: path.map(decodeURIComponent), params: new URLSearchParams(query) };
}

export function useHashRoute(): HashRoute {
  const [hash, setHash] = useState(window.location.hash);
  useEffect(() => {
    const onChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  return parseHashRoute(hash);
}

export function useCurrentSection(): Section {
  return findSection(useHashRoute().section);
}
